export class UploadInputChange {
    constructor(optionalOptions = {}) {
        this._inputs = document.querySelectorAll('.upload-input');

        if (!this._inputs) {
            this.destructor();
            return true;
        }

        let inputId

        for (let i = 0; i < this._inputs.length; ++i) {
            let input = this._inputs[i];
            input.addEventListener('change', (event) => {
                inputId = input.id

                if (input.files && input.files[0]) {
                    let reader = new FileReader();
                    let extension = input.files[0].name.split('.').pop().toLowerCase()

                    if (extension !== 'mp4') {
                        reader.onload = function (e) {
                            var imgSrc = document.querySelector('img[data-target="' + inputId + '"]');
                            var loading = imgSrc.parentNode.querySelector('.base-form-upload-input-loading');

                            loading.style.display = 'block';

                            imgSrc.src = e.target.result;

                            setTimeout(() => {
                                input.parentNode.querySelector('.base-form-upload-input--wrap').classList.remove('upload-button--empty')
                                loading.style.display = 'none';
                            }, 1500)
                        }
                        reader.readAsDataURL(input.files[0]); // convert to base64 string
                    }
                }
            });
        }
    }

    destructor() {
        this._inputs = null;
    }
}

export default new UploadInputChange();